import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CatalogosLogisticaService {

  path: string = '../../../assets/images/icon/';

  constructor() {
  }

  catalogoAsesorIcon() {
    return {
      csv: this.path + 'csv.svg',
    };
  }

  catalogoEstados() {
    return [
      {clave: 'CREADO', valor: 'CREADO',  proceso: "INICIAL"},
      {clave: 'REVISION_HABILITADA', valor: 'REVISION_HABILITADA', proceso: "PLANIFICACION"},
      {clave: 'REVISION_ACEPTADA', valor: 'REVISION_ACEPTADA', proceso: "PLANIFICACION"},
      {clave: 'REVISION_CONDICIONADA', valor: 'REVISION_CONDICIONADA', proceso: "PLANIFICACION"},
      {clave: 'REVISION_RECHAZADA', valor: 'REVISION_RECHAZADA', proceso: "PLANIFICACION"},
      {clave: 'CONVOY_PLANIFICADO', valor: 'CONVOY_PLANIFICADO', proceso: "PLANIFICACION"},
      {clave: 'GARITA_REVISADA', valor: 'GARITA_REVISADA', proceso: "GARITA"},
      {clave: 'GARITA_APROBADO', valor: 'GARITA_APROBADO', proceso: "GARITA"},
      {clave: 'BALANZA_IN',     valor: 'BALANZA_IN', proceso: "Anden"},
      {clave: 'BALANZA_OUT',    valor: 'BALANZA_OUT', proceso: "BALANZA"},
      {clave: 'ANDEN_ASIGNADO', valor: 'ANDEN_ASIGNADO', proceso: "operador"},
      {clave: 'ANDEN_CARGANDO', valor: 'ANDEN_CARGANDO', proceso: "ANDEN"},
      {clave: 'ANDEN_CARGADO', valor: 'ANDEN_CARGADO', proceso: "ANDEN"},
      {clave: 'DOCUMENTOS_INICIO', valor: 'DOCUMENTOS_INICIO', proceso: "DOCUMENTOS"},
      {clave: 'DOCUMENTADO', valor: 'DOCUMENTOS_INICIO', proceso: "DOCUMENTOS"},
      {clave: 'ASIGNAR_SELLOS', valor: 'DOCUMENTOS_INICIO', proceso: "sellos"},
      {clave: 'COMPLETADO', valor: 'DOCUMENTOS_INICIO', proceso: "BALANZA"},
    ];
  }

  getBooleanSiNo() {
    return [
      {clave: true, valor: 'SI'},
      {clave: false, valor: 'NO'}
    ];
  }

  catalogoAprobacionGarita() {
    return [
      {clave: 7, valor: 'Aprobado'},
      {clave: 6, valor: 'Rechazado'},
    ];
  }

  catalogoTipoColaborador() {
    return [
      {clave: 'Verificador',  valor: 'Verificador'},
      {clave: 'Supervisor',   valor: 'Supervisor'},
      {clave: 'Colaborador',  valor: 'Colaborador'},
    ];
  }

  catalogoTiposMaterial() {
    return [
      {clave: 'Pallet', valor: 'Pallet'},
      {clave: 'Envase', valor: 'Envase'},
      {clave: 'Material de empaque', valor: 'Material de empaque'},
      {clave: '3PL', valor: '3PL'},
    ];
  }

  catalogoPreguntasGarita() {
    return [
      {clave: 1, valor: '¿Cuenta con los equipos de seguridad vial?',   name:'seguridadVial'},
      {clave: 2, valor: 'Equipos de protección personal',               name:'proteccionPersonal'},
      {clave: 3, valor: '¿Las llantas se encuentran en buen estado?',   name:'llantasOperativas'},
      {clave: 4, valor: '¿Tiene llanta de emergencia en buenas condiciones?',  name: 'llantaEmergencia'},
      {clave: 5, valor: 'Pata mecánica del chasis',                     name: 'brazoChassis' },
      {clave: 6, valor: 'Revisión de los compartimientos en el interior de la cabina y área de litera',  name: 'interiores'},
      {clave: 7, valor: 'Revisión de los compartimientos en el exterior de la cabina y área de litera',  name: 'exteriores'},
    ];
  }

  catalogoPreguntasVehicular() {
    return [
      {clave: 1, valor: "Pared delantera -(filtraciones, desniveles, remaches y parches que comprometan la integridad de la carga)", name:'filtracionFront'},
      {clave: 2, valor: 'Lado izquierdo - (filtraciones, desniveles, remaches y parches que comprometan la integridad de la carga)',  name:'filtracionLeft'},
      {clave: 3, valor: 'Lado derecho* - (filtraciones, desniveles, remaches y parches que comprometan la integridad de la carga)',  name:'filtracionRight'},
      {clave: 4, valor: 'Piso - (el texto se ve cortado en la imagen; comienza con “filtración de luz, desnivelado, remaches y parches … y continúa en el mismo sentido de integridad de la carga)',  name: 'filtracionPiso'},
      {clave: 5, valor: 'Techo - (filtraciones, puntas, remaches y parches que comprometan la integridad de la carga)',  name: 'filtracionUp' },
      {clave: 6, valor: 'Puertas - (cauchos, bisagras, manijas, barras en buen estado)',  name: 'puertas'},
      {clave: 7, valor: 'Exterior y bastidor - (vigas desde la pared frontal hasta las puerta)',  name: 'exterior'},
      {clave: 8, valor: 'Estructura y lona de paredes - (seguro para sello, guías correctas, lona y remaches de sujeción en buen estado)',  name: 'estructura'},
      {clave: 9, valor: 'Área de la quinta rueda -(estructura de fijación el pin)',  name: 'ruedas'},
      {clave: 10, valor: 'Luces principales y de stop, pito de retro',  name: 'luces'},
      {clave: 11, valor: 'Limpio, sin residuo de productos y libre de olores',  name: 'limpieza'},
      {clave: 12, valor: 'Fumigación del vehículo ',  name: 'fumigacion'},
    ];
  }
  
  getCabeceraDoc() {
    return [
      {clave: 'fleteSap', valor: 'Flete SAP'},
      {clave: 'guiaRemision', valor: 'Guia'},
      {clave: 'centroOrigen', valor: 'Centro'},
      {clave: 'agenciaOrigen', valor: 'Agencia'},
      {clave: 'fletePesoNeto', valor: 'Total Peso Neto'},
      {clave: 'fletePesoBruto', valor: 'Total Peso Bruto'},
      {clave: 'esRegistro', valor: 'Es parte del Registro'},
    ];
  }

  getCabeceraCargas() {
    return [
      {clave: 'fleteSap', valor: 'Flete SAP'},
      {clave: 'guiaRemision', valor: 'Guia'},
      {clave: 'centroOrigen', valor: 'Centro'},
      {clave: 'agenciaOrigen', valor: 'Agencia'},
      {clave: 'fletePesoNeto', valor: 'Total Peso Neto'},
      {clave: 'fletePesoBruto', valor: 'Total Peso Bruto'},
    ];
  }

  getColumnDefs() {
    let columnDefs = [
      { filter: true, resizable: true, width: 120, field: 'garitaTicket', floatingFilter: true},
      { filter: true, resizable: true, width: 120, field: 'balanzaTicket', floatingFilter: true},
      { filter: true, resizable: true, width: 150, field: 'estado' },
      { filter: true, resizable: true, width: 230, field: 'choferNombre' },
      { filter: true, resizable: true, width: 120, field: 'placa' },
      //{ filter: true, resizable: true, field: 'choferCedula' },
      //{ filter: true, resizable: true, field: 'proveedorId' },
      { filter: true, resizable: true, field: 'proveedorNombre' },
      //{ filter: true, resizable: true, field: 'centroOrigen' },
      { filter: true, resizable: true, field: 'centroOrigenNombre' },
      //{ filter: true, resizable: true, field: 'centroDestino' },
      { filter: true, resizable: true, field: 'centroDestinoNombre' },
      { filter: true, resizable: true, field: 'clienteNombre' },
      { filter: true, resizable: true, field: 'furgon' },
      { filter: true, resizable: true, width: 120, sortable: true, sort: 'desc', field: 'idViaje' },
      { filter: true, resizable: true, field: 'fechaLlegada' },
      { filter: true, resizable: true, width: 170, field: 'fechaRecepcion', headerName: 'Fecha Recepción' },
    ];

    return columnDefs;
  }

  getColumnDefsConvoy() {
    let columnDefs = [
      { filter: true, sortable: true, sort: 'desc', width: 90,  field: 'idConvoy' },
      { field: 'grupo', resizable: true},
      { width: 95, field: 'totalViajes', resizable: true},
      { field: 'observacion', resizable: true },
      { field: 'estado', width: 150, resizable: true },
      { field: 'fechaSalida', width: 150, resizable: true },
      { field: 'creado', resizable: true },
      { filter: true, resizable: true, width: 170, field: 'fechaRecepcion', headerName: 'Fecha Recepción' },
    ];

    return columnDefs;
  }
  
  //Usar este registro para pasar parametros por defecto del GRID, 
  getDefaultColDef() {
    let defaultGrid = {
      editable  : false,
      filter    : true,
      //floatingFilter: true,
      resizable : true,
      sortable  : true,
      minWidth  : 150,
      flex      : 1,
    };

    return defaultGrid;
  }

  catalogoEstadoLogico() {
    return [
      {clave: 1, valor: 'Activo',},
      {clave: 0, valor: 'Inactivo',},
    ]
  }

  catalogoTipoArea() {
    return [
      {clave: 'ACTIVO', valor: 'ACTIVO',},
      {clave: 'ESPERA', valor: 'ESPERA'},
    ]
  }

  // MATRIZ DE CAMPOS QUE SE A LIMPIAR Y OBLIGAR DINAMICAMENTE DEPENDIENDO DEL TIPO
  get fieldbyType(): Record<string, string[]>{
    let matrizCampos = {
      'VENTA': [
        'cliente',
        'clienteNombre',
        'cantidadDespacho',
        'orden',
        'buque',
        'tipoOrdenBalanza',
        'areaId'
      ],
      'COMPRA': [
          'orden',
          'centroDestino',
          'almacenDestino',
          'compras.proveedorCompra',
          'compras.proveedorCompraName',
          'compras.extractoraId',
          'compras.extractoraAcidez',
          'compras.extractoraHumedad',
          'compras.extractoraImpureza',
          'compras.extractoraPesoNeto',
          'compras.extractoraPesoBruto',
          'compras.extractoraPesoTara',
          'tipoOrdenBalanza',
          'areaId'
        ],
      'TRASLADO': [
          'centroDestino',
          'almacenDestino',
          'tipoOrdenBalanza',
          'areaId'
        ],
      'INFORMATIVO': [
          'areaId'
        ],
      };
      return matrizCampos;
    }

}